import { useTheme } from "@mui/system";
import useStyles from "./styles";
import { Outlet, useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

export default function ClientViewpoint() {
	const theme = useTheme();
	const styles = useStyles(theme);
	const navigate = useNavigate();

	const path = window.location.pathname;
	let isMirror = path.includes("mirror");
	const isInternal = Boolean(localStorage.getItem("user"));
	const loginCliente = Boolean(localStorage.getItem("userCliente"));
	if (loginCliente && isInternal && !isMirror) {
		window.history.replaceState(null, null, `mirror${path}`);
		isMirror = true;
	}

	return (
		<>
			{isMirror && (
				<>
					<Box sx={styles.pageTopSpace}></Box>
					<Box sx={styles.contentBox}>
						<Box sx={styles.boxButton}>
							<Button
								onClick={() => {
									localStorage.removeItem("logInternoCliente");
									localStorage.removeItem("userCliente");
									localStorage.removeItem("perfilCliente");
									navigate("/administracao/usuarios");
								}}
								variant="outlined"
								startIcon={<ArrowBack />}
								size="small"
								sx={styles.returnBt}
							>
								RETORNAR AO MODO NORMAL
							</Button>
							<Typography sx={styles.helperTitle}>
								MODO DE VISUALIZAÇÃO DA TELA DO CLIENTE!
							</Typography>
						</Box>
					</Box>
				</>
			)}

			<Outlet />
		</>
	);
}
